import axios, { AxiosError, CanceledError } from 'axios';

export function isCanceledAxiosError(error: unknown) {
  return (
    axios.isCancel(error) ||
    error instanceof CanceledError ||
    (error instanceof AxiosError && error.code === 'ERR_CANCELED')
  );
}
